import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import Notifications from './plugins/notifications'
import DatetimePicker from 'vuetify-datetime-picker'
import "@/assets/css/materialdesignicons.min.css"
import "@/assets/css/roboto.css"

/* layouts */
import AppLayout from './layouts/AppLayout';
import SimpleLayout from './layouts/SimpleLayout';

/* Nprogress */
import NProgress from 'vue-nprogress';
import './assets/css/progress-bar.css';
import store from './store'

const options = {
  latencyThreshold: 200,
  router: false,
  http: true
};
Vue.use(NProgress, options);
const nprogress = new NProgress();

Vue.filter('truncate', function (text, length, suffix) {
  if (text.length > length) {
      return text.substring(0, length) + suffix;
  } else {
      return text;
  }
});

import moment from 'moment';
Vue.filter('formatDate', function(value) {
  if (!value) return '';
  return moment(String(value)).format('DD/MM/YYYY')
});

Vue.filter('cpf_formatado', function (value) {
  if (!value) return ''
  let pattern = '###.###.###-##'
  let i = 0;
  value = value.toString()
  value = value.padStart(11, '0');
  return pattern.replace(/#/g, function () {
    return value[i++]
  });
})

import "vue-wysiwyg/dist/vueWysiwyg.css";
import wysiwyg from "vue-wysiwyg";
Vue.use(wysiwyg, {});

import BotaoExcluirComConfirmacao from './components/BotaoExcluirComConfirmacao.vue';
import BotaoEmailComConfirmacao from './components/BotaoEmailComConfirmacao.vue';

Vue.use(Notifications);
Vue.use(DatetimePicker);

Vue.config.productionTip = false

Vue.component('app-layout', AppLayout);
Vue.component('simple-layout', SimpleLayout);
Vue.component('botao-excluir-com-confirmacao', BotaoExcluirComConfirmacao);
Vue.component('botao-email-com-confirmacao', BotaoEmailComConfirmacao);

new Vue({
  vuetify,
  router,
  nprogress,
  store,
  render: h => h(App)
}).$mount('#app')
